import React, { Component } from "react";
import * as echarts from "echarts/dist/echarts.js";
import "bootstrap/dist/css/bootstrap.css";
import "./dashboard.css";
import { ThemeProvider } from "styled-components";

class HeaterLineGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphLen: 0,
      base: new Date(),
      oneDay: 86400000,
      date: [],
      value1: [0],
      value2: [0],
      value3: [0],
      value4: [0],
      value5: [0],
      now: new Date(),
    };
  }

  async componentDidMount() {
    if (this.props.chartDateInitial) {
      this.setState({
        date: this.props.chartDateInitial,
        value1: this.props.chartValue1Initial,
        value2: this.props.chartValue2Initial,
        value3: this.props.chartValue3Initial,
        value4: this.props.chartValue4Initial,
        value5: this.props.chartValue5Initial,
      });
    }

    this.chart = echarts.init(document.getElementById("graph-area"));
    const tickNumber = 1000;
    this.timerID = setInterval(() => this.tick(), tickNumber);
    this.generateGraph();
    // this.setState({ playPause: this.props.playPause });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.chart) return;

    // Only update data — never override legend or series definitions
    this.chart.setOption({
      xAxis: { data: this.state.date },
      series: [
        { name: this.props.chartLegend1, data: this.state.value1 },
        { name: this.props.chartLegend2, data: this.state.value2 },
        { name: this.props.chartLegend3, data: this.state.value3 },
        { name: this.props.chartLegend4, data: this.state.value4 },
        { name: this.props.chartLegend5, data: this.state.value5 },
      ],
    });
  }

  // componentDidUpdate() {
  //   if (!this.chart) return;

  //   this.chart.setOption({
  //     xAxis: { data: this.state.date },
  //     series: [
  //       { name: this.props.chartLegend1, data: this.state.value1 },
  //       { name: this.props.chartLegend2, data: this.state.value2 },
  //       { name: this.props.chartLegend3, data: this.state.value3 },
  //       { name: this.props.chartLegend4, data: this.state.value4 },
  //       { name: this.props.chartLegend5, data: this.state.value5 },
  //     ],
  //   });
  // }

  // componentDidUpdate(prevProps) {
  //   if (!this.chart) return;

  //   if (
  //     this.props.modeBox === "Real-time" &&
  //     prevProps.modeBox !== "Real-time"
  //   ) {
  //     this.resetRealtimeWindow();
  //     return;
  //   }

  //   this.chart.setOption({
  //     xAxis: { data: this.state.date },
  //     series: [
  //       { name: this.props.chartLegend1, data: this.state.value1 },
  //       { name: this.props.chartLegend2, data: this.state.value2 },
  //       { name: this.props.chartLegend3, data: this.state.value3 },
  //       { name: this.props.chartLegend4, data: this.state.value4 },
  //       { name: this.props.chartLegend5, data: this.state.value5 },
  //     ],
  //   });
  // }

  resetRealtimeWindow() {
    this.setState({
      date: [],
      value1: [],
      value2: [],
      value3: [],
      value4: [],
      value5: [],
    });

    this.chart.setOption({
      xAxis: { data: [] },
      series: [
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
      ],
    });
    // this.props.playPause = true;
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    // this.addData(false);
    this.addData();
    // this.chart.setOption({
    //   yAxis: {
    //     max: this.props.maxTemp + 5.0,
    //     min: this.props.minTemp - 5.0,
    //   },
    //   xAxis: {
    //     data: this.state.date,
    //     axisTick: { show: true },
    //     splitLine: { show: true },
    //   },
    //   series: [
    //     { name: `${this.props.chartLegend1}`, data: this.state.value1 },
    //     { name: `${this.props.chartLegend2}`, data: this.state.value2 },
    //     { name: `${this.props.chartLegend3}`, data: this.state.value3 },
    //     { name: `${this.props.chartLegend4}`, data: this.state.value4 },
    //     { name: `${this.props.chartLegend5}`, data: this.state.value5 },
    //   ],
    // });
  }

  addData() {
    const raw = localStorage.getItem("pointsOnChart");
    const pointsOnChart = Number(raw) || 50; // safe default

    const ts = this.props.dataTimeStamp;
    let timeSource = new Date(ts);
    if (isNaN(timeSource.getTime())) timeSource = new Date();

    const formattedTime = [
      timeSource.getHours().toString().padStart(2, "0"),
      timeSource.getMinutes().toString().padStart(2, "0"),
      timeSource.getSeconds().toString().padStart(2, "0"),
    ].join(":");

    if (!this.props.playPause) return;

    this.setState((prev) => {
      const date = [...prev.date, formattedTime];
      const v1 = [...prev.value1, this.props.chartValue1];
      const v2 = [...prev.value2, this.props.chartValue2];
      const v3 = [...prev.value3, this.props.chartValue3];
      const v4 = [...prev.value4, this.props.chartValue4];
      const v5 = [...prev.value5, this.props.chartValue5];

      while (
        date.length > pointsOnChart &&
        this.props.modeBox === "Real-time"
      ) {
        date.shift();
        v1.shift();
        v2.shift();
        v3.shift();
        v4.shift();
        v5.shift();
      }

      return {
        date,
        value1: v1,
        value2: v2,
        value3: v3,
        value4: v4,
        value5: v5,
      };
    });
  }

  // addData() {
  //   if (!this.props.playPause) return;

  //   const ts = this.props.dataTimeStamp;
  //   const timeValue = isNaN(new Date(ts).getTime())
  //     ? Date.now()
  //     : new Date(ts).getTime();

  //   this.setState((prev) => {
  //     const date = [...prev.date, timeValue];
  //     const v1 = [...prev.value1, this.props.chartValue1];
  //     const v2 = [...prev.value2, this.props.chartValue2];
  //     const v3 = [...prev.value3, this.props.chartValue3];
  //     const v4 = [...prev.value4, this.props.chartValue4];
  //     const v5 = [...prev.value5, this.props.chartValue5];

  //     const pointsOnChart = Number(localStorage.getItem("pointsOnChart")) || 50;

  //     while (
  //       date.length > pointsOnChart &&
  //       this.props.modeBox === "Real-time"
  //     ) {
  //       date.shift();
  //       v1.shift();
  //       v2.shift();
  //       v3.shift();
  //       v4.shift();
  //       v5.shift();
  //     }

  //     return {
  //       date,
  //       value1: v1,
  //       value2: v2,
  //       value3: v3,
  //       value4: v4,
  //       value5: v5,
  //     };
  //   });
  // }

  generateGraph() {
    var option = {
      legend: {
        type: "scroll",
        data: [
          `${this.props.chartLegend1}`,
          `${this.props.chartLegend2}`,
          `${this.props.chartLegend3}`,
          `${this.props.chartLegend4}`,
          `${this.props.chartLegend5}`,
        ],
        center: "50%",
        top: "0%",
        orient: "horizontal",
        align: "auto",
        padding: 3,
        textStyle: {
          fontStyle: "normal",
          fontSize: 10,
          fontWeight: "bold",
          color: "grey",
        },
        backgroundColor: "transparent",
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        axisLabel: {
          fontStyle: "normal",
          fontSize: 8,
          fontWeight: "normal",
          color: "orange",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#e0e0e0",
            type: "solid", // or "dashed"
            width: 1,
          },
        },
        data: this.state.date,
      },
      yAxis: {
        show: true,
        type: "value",
        axisLabel: {
          fontStyle: "normal",
          fontSize: 8,
          fontWeight: "normal",
          color: "orange",
        },
      },
      dataZoom: [
        {
          type: "slider",
          show: true,
          xAxisIndex: [0],
          start: 1,
          end: 100,
          height: 20,
        },
        { type: "inside", xAxisIndex: [0], start: 1, end: 100 },
        {
          type: "inside",
          yAxisIndex: 0,
          filterMode: "none",
        },
        {
          type: "slider",
          yAxisIndex: 0,
          right: "8%",
          width: 20,
        },
      ],
      series: [
        {
          name: this.props.chartLegend1, // "PV Power",
          type: "line",
          symbol: "none",
          color: "orange",
          smooth: 0.25,
          data: this.state.value1,
        },
        {
          name: this.props.chartLegend2, // "Battery Power",
          type: "line",
          symbol: "none",
          color: "dodgerBlue",
          smooth: 0.25,
          data: this.state.value2,
        },
        {
          name: this.props.chartLegend3, // "Grid Power",
          type: "line",
          symbol: "none",
          color: "magenta",
          smooth: 0.25,
          data: this.state.value3,
        },
        {
          name: this.props.chartLegend4, // "Building Power",
          type: "line",
          symbol: "none",
          color: "green",
          smooth: 0.25,
          data: this.state.value4,
        },
        {
          name: this.props.chartLegend5, // "Room Temp.",
          type: "line",
          symbol: "none",
          color: "red",
          smooth: 0.25,
          data: this.state.value5,
        },
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          animation: false,
          type: "cross",
          label: { backgroundColor: "#6a7985", precision: "2" },
        },
        hideDelay: 2000,
      },
    };
    // this.chart.clear();

    this.chart.setOption(option);
    // this.resetRealtimeWindow();
    // return;
  }

  render() {
    return <div id="graph-area" />;
  }
}

export default HeaterLineGraph;
